import type { ComponentStyleConfig } from '@chakra-ui/theme';

const GuestDropdown: ComponentStyleConfig = {
  baseStyle: {
    backgroundColor: 'white',
    borderWidth: '1px',
    borderRadius: 'full',
    borderColor: 'neutral.500',
    _focusWithin: {
      borderColor: 'black',
    },
    paddingBottom: '3px',
  },
  sizes: {
    sm: {
      h: '32px',
      minW: '72px',
      fontSize: 'sm',
      fontWeight: 500,
    },
    md: {
      h: '40px',
      minW: '76px',
      fontSize: 'md',
      fontWeight: 500,
    },
    lg: {
      h: '48px',
      minW: '80px',
      fontSize: 'lg',
      fontWeight: 500,
    },
  },
  defaultProps: {
    size: 'sm',
  },
};

export default GuestDropdown;
